import { render, staticRenderFns } from "./ReportTabGroupMeals.vue?vue&type=template&id=d7c95314"
import script from "./ReportTabGroupMeals.vue?vue&type=script&lang=js"
export * from "./ReportTabGroupMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports